import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTrigger,
} from "@/components/ui/dialog";
import { PenLine, Check } from "lucide-react";
import { useState } from "react";
import { cn } from "@/lib/utils";
import { colors } from "@/utils/colors";
import { signMyTimeEntryMirrorReport } from "@/Api/timeEntryMirror";
import { useToastNavigate } from "@/utils/toastNavigate";
import { LoaderSpin } from "@/components/Loaders";

export const SignReportBtn = ({
  employeeReportUuid,
  periodLabel,
  onSigned,
}: {
  employeeReportUuid: string;
  periodLabel: string;
  onSigned: () => void;
}) => {
  const { toast } = useToastNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [signing, setSigning] = useState(false);

  const handleSign = async () => {
    setSigning(true);
    const { data, ok } = await signMyTimeEntryMirrorReport(employeeReportUuid);
    setSigning(false);
    if (!ok) {
      toast({
        description: data?.message || "Erro ao assinar o espelho de ponto",
        variant: "destructive",
      });
      return;
    }
    setIsOpen(false);
    toast({ description: "Espelho de ponto assinado!", action: <Check color="#1edc2b" /> });
    onSigned();
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button type="button" size="sm" className={cn(colors.bg_primary)}>
          <PenLine className="size-4" />
          Assinar
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[420px]">
        <DialogHeader>
          <DialogDescription className="text-lg">
            Confirmar assinatura
          </DialogDescription>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          Ao confirmar, você declara estar de acordo com o espelho de ponto do
          período <strong>{periodLabel}</strong>. Essa ação não pode ser
          desfeita.
        </p>
        <DialogFooter>
          <Button
            type="button"
            className={cn("w-full", colors.bg_primary)}
            disabled={signing}
            onClick={handleSign}
          >
            {signing ? <LoaderSpin /> : "Confirmar assinatura"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
